<ng-container *ngIf="anchor$ | async as anchor">
  <div
    class="image-hover-viewer"
    [class.image-hover-viewer--above]="showAbove(anchor)"
    [style.top.px]="top(anchor)"
    [style.left.px]="left(anchor)"
  >
    <div class="image-hover-viewer__image" [style.height.px]="imageBoxHeight">
      <img *ngIf="anchor.src" [src]="anchor.src" alt="" />
    </div>
    <div class="image-hover-viewer__info">
      <div class="image-hover-viewer__name">{{ anchor.name }}</div>
      <div *ngIf="anchor.variant" class="image-hover-viewer__variant">{{ anchor.variant }}</div>
    </div>
    <div class="image-hover-viewer__arrow" [style.left.px]="arrowLeft(anchor)"></div>
  </div>
</ng-container>
